var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_843_8590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8741 1.95782H10.6899C10.6093 1.95782 10.5335 1.9973 10.4862 2.06204L6.0003 8.2453L1.51444 2.06204C1.46707 1.9973 1.39128 1.95782 1.31075 1.95782H0.126518C0.0238846 1.95782 -0.0361164 2.07467 0.0238846 2.15835L5.59134 9.83375C5.79345 10.1116 6.20714 10.1116 6.40767 9.83375L11.9751 2.15835C12.0367 2.07467 11.9767 1.95782 11.8741 1.95782Z",
    fill: "white",
    fillOpacity: 0.65
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_843_8590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/Down.4db36ebd6728e3cbce01f12d1a9e9a48.svg";
export { ForwardRef as ReactComponent };